import { post, get } from '@http/request'
const { VUE_APP_API_URL } = process.env
export const batchOrderNew = {
  downLoadFile: reqData => post(`/vip/excel/international/outer/downloadTemplate`, reqData, { responseType: 'blob' }),
  importFile: `${VUE_APP_API_URL}/vip/excel/international/outer/excelImport`,
  reqGood: param => get(`/vip/baseData/list`, param),
  sendOrder: params => post(`/vip/order/international/outer/batchAdd`, params),
  reqReceive: param => get(`/vip/order/international/outer/listAllCountry`, param)
}
